<template>
  <div>
    <v-toolbar flat color="white" pt-5 mt-5>
      <v-btn round color="primary" @click="addItem()">Add Inventory Type</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="stocktypes"
      item-key="id"
      :search="search"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
            <v-icon @click="editItem(props.item)">edit</v-icon>
          <v-icon @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td  class="text-xs-center">{{props.item.name}}</td>
        <td  class="text-xs-center">{{props.item.code}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <v-dialog v-model="addInventoryType" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">ADD INVENTORY TYPE</h1>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
          <v-text-field label="Code" v-model="item.code"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="addInventoryType=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name" @click="saveInventoryType">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editInventoryType" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">EDIT INVENTORY TYPE</h1>
        </v-toolbar>
        <v-card-text>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
          <v-text-field label="Code" v-model="item.code"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="editInventoryType=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name" @click="saveEditedInventoryType">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
export default {
  props: ["stocktypes"],
  data() {
    return {
      addInventoryType: false,
      editInventoryType: false,
      search: '',
      item: {},
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Code",
          align: "center",
          value: "code"
        }
      ]
    };
  },
  methods: {
      editItem(item) {
        if(this.authUpdate(this.$store.state.currentRoute)){
      this.item = Object.assign({}, item);
      this.editInventoryType = true;
      }
    },
    deleteItem(item) {
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to delete this Stock Type?") &&
        Api()
          .put("/stockType/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(this.$emit("stockTypeChange"));
        }
    },
    addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){
            this.addInventoryType=true
        }
    },
    saveInventoryType() {
      Api()
        .post("/stockType", {
          name: this.item.name,
          code: this.item.code,
          isActive: true,
          isDelete: false
        })
        .then(() => {
          (this.addInventoryType = false),
            (this.item = {}),
            this.$emit("stockTypeChange");
        });
    },
    saveEditedInventoryType() {
      Api()
        .put("/stockType/"+this.item.id, {
          name: this.item.name,
          code: this.item.code,
          isActive: true,
          isDelete: false
        })
        .then(() => {
          (this.editInventoryType = false),
            (this.item = {}),
            this.$emit("stockTypeChange");
        });
    }
  }
};
</script>

<style>
</style>